var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "icon-wrapper", class: _vm.classes, style: _vm.cssProps },
    [
      _c(
        "div",
        {
          staticClass: "icon",
          attrs: { title: _vm.compTitle },
          on: { click: _vm.onClick }
        },
        [_vm._t("default")],
        2
      ),
      _vm.compSubtitle
        ? _c("span", { staticClass: "sub-text" }, [
            _vm._v(_vm._s(_vm.compSubtitle))
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }